<template>
  <div
    class="d-flex flex-column justify-content-start align-items-center h-100"
  >
    <div class="row mt-5">
      <Subheader class="col">{{
        $t($route.meta.titleKey, $route.meta.fallbackLabel)
      }}</Subheader>
    </div>
    <div
      class="row flex-grow-1 align-items-center team-selection-tour justify-content-center"
    >
      <div
        v-if="showNoAvailabeTeamMessage"
        class="no-team-message text-block--primary"
      >
        {{
          $t(
            'web_no_team_to_join_tournament',
            'Sorry, you have no team to join this tournament'
          )
        }}
      </div>
      <div
        v-for="item in availableTeams"
        :key="item.clan.id"
        class="col clan-card text-center"
      >
        <Avatar
          class="clan-card_avatar"
          type="clan"
          :img-url="item.clan.logo"
          :size="80"
        />
        <TextBlock
          class="d-block mw-100 px-3 mb-0 text-truncate clan-card_name"
          :text="item.clan.name"
          :size="1"
        />
        <div v-if="currentTournament.full_teams" class="team-count">
          <span class="text-block--primary"
            >{{ $t('web_player_title', 'Players') }}:
          </span>
          <span
            :class="{
              'full-team':
                item.clan.members_count >= currentTournament.squad_size,
            }"
          >
            <span>{{ item.clan.members_count }}</span> <span>/</span>
            <span>{{ currentTournament.squad_size }}</span>
          </span>
        </div>
        <div class="spacer"></div>
        <div
          class="team-select-action-wrapper d-flex align-items-center justify-content-center w-100"
        >
          <Button
            v-if="!isLoading && isAbleToJoin(item)"
            class="btn-primary"
            :disabled="
              isLoading ||
                account.isOrganization ||
                (item.join_access &&
                  item.join_access !== 'None' &&
                  item.join_access !== 'Invited')
            "
            @click.prevent.stop="
              teamSelected(registrationTournament, item.clan.id)
            "
          >
            {{ $t('_web_tournament_statusbar-join', 'Join') }}
          </Button>
        </div>
        <span v-if="!isEnoughPlayers(item)" class="card-error-message">{{
          $t('web_not_enough_players', 'Not enough players')
        }}</span>
        <!-- <span v-if="isAlreadyJoined(item)" class="card-error-message">{{
          $t('web_team_application_sent', 'Application sent')
        }}</span> -->
      </div>
      <CreateTeamCard v-if="showCreateTeamCard" />
    </div>
    <div class="row flex-grow-1 align-items-end justify-content-center mb-5">
      <BackBtn hide-icon history-mode />
    </div>
    <Preloader v-if="isLoading" :is-loading="isLoading" has-backdrop />
  </div>
</template>

<script>
import joinAction from '@/views/tournaments/mixins/joinTournamentAction';
import Subheader from '@/components/atoms/Subheader';
import Avatar from '@/components/images/Avatar';
import TextBlock from '@/components/atoms/TextBlock';
import Button from '@/components/atoms/HeraFormBtn';
import BackBtn from '@/components/common/GoBackBtn.vue';
import CreateTeamCard from '@/views/tournaments/player/tournament-registration/components/CreateTeamCard.vue';
import Preloader from '@/components/common/HeraListPreloader';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'TournamentRegistrationTeamSelect',
  components: {
    Subheader,
    Avatar,
    TextBlock,
    Button,
    BackBtn,
    CreateTeamCard,
    Preloader,
  },
  mixins: [joinAction],
  data() {
    return {
      availableTeams: [],
      participants: [],
    };
  },

  computed: {
    ...mapState('my', ['account', 'accountId']),
    ...mapGetters([
      'registrationTournament',
      'currentTournament',
      'registrationData',
    ]),
    tournamentID() {
      return this.$route.params.tournamentID;
    },

    showCreateTeamCard() {
      if (this.isLoading) {
        return false;
      }
      return !this.currentTournament.full_teams;
    },

    showNoAvailabeTeamMessage() {
      if (this.isLoading) {
        return false;
      }
      return (
        this.currentTournament.full_teams && this.availableTeams.length == 0
      );
    },
  },

  created() {
    this.afterJoin = this.joinSuccessHandler;
    this.setLoading();
    this.getCompetitionPlayersStatus({
      id: this.tournamentID,
      params: {
        registration_token: this.$route.query.registration_token,
      },
    })
      .then(data => {
        this.availableTeams = data;
      })
      .then(() => this.getTournamentParticipants({ id: this.tournamentID }))
      .then(response => {
        this.participants = response.items.map(team => team.id);
      })
      .catch(this.errorNotify)
      .finally(this.unsetLoading);
  },

  methods: {
    ...mapActions([
      'getCompetitionPlayersStatus',
      'getTournamentParticipants',
      'errorNotify',
    ]),
    ...mapMutations(['setRegistrationData']),

    isEnoughPlayers(team) {
      if (this.currentTournament.full_teams) {
        return team.clan.members_count >= this.currentTournament.squad_size;
      }
      return true;
    },

    isAlreadyJoined(team) {
      return this.participants.includes(team.clan.id);
    },

    isAbleToJoin(team) {
      return this.isEnoughPlayers(team);
    },

    joinSuccessHandler() {
      this.$router.go(-1);
    },

    teamSelected(tournament, clan) {
      if (!this.currentTournament.requires_registration_form) {
        this.setRegistrationData({
          ...this.registrationData,
          clanId: clan,
        });
        this.$router.push({
          name: 'tournamentRegistrationCreateRoster',
          params: {
            clanID: clan,
          },
          query: {
            ...this.$route.query,
          },
        });
      } else {
        this.selectJoinScenario(tournament, clan);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.team-count {
  color: $ph-error;
}
.team-selection-tour {
  gap: 20px;
  .clan-card {
    height: 16rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0;
    gap: 12px;
    max-width: 13rem;
    padding: 20px;
    .full-team {
      span {
        color: $ph-green;
      }
    }

    .clan-card_name {
      font-weight: bold;
    }

    .card-error-message {
      font-size: 0.9rem;
      color: $ph-error;
    }
  }
}

.spacer {
  flex: 1;
}

.no-team-message {
  font-size: 1.25rem;
}
</style>
